import React from 'react';
import { connect } from 'react-redux';

import CurrencySign from 'components/price/CurrencySign.component';

class TransactionReview extends React.Component {
  service = (id) => {
    if (this.props.services.length === 0) {
      return { name: 'Loading...', color: '#FFFFFF' };
    }
    let c;
    let s;
    for (let i = 0; i < this.props.services.length; i += 1) {
      const category = this.props.services[i];
      s = category.services.find((j) => j.id === id);
      if (s) {
        c = category;
        break;
      }
    }
    if (c && s) {
      return { name: s.name, color: c.color };
    }
    return { name: 'deleted service', color: '#FFFFFF' };
  };
  stylistName = (id) => {
    if (this.props.stylistList.length === 0) {
      return 'Loading...';
    }
    const stylist = this.props.stylistList.find((s) => s.id === id);
    if (stylist) {
      return stylist.user_name;
    }
    return 'Unknown';
  };

  render() {
    const service = this.service(this.props.service.serviceId);
    return (
      <div className="procedure">
        <span
          className="dot-color"
          style={{
            backgroundColor: service.color,
          }}
        />
        <div>
          <span className="stylist">
            {service.name}
            {this.props.showStylist && <span> {`with ${this.stylistName(this.props.service.stylistId)}`}</span>}
          </span>

          <span className="price">
            <CurrencySign />
            {this.props.service.finalPrice}
          </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { stylistList, services },
  } = state;
  return {
    stylistList,
    services,
  };
}

export default connect(mapStateToProps)(TransactionReview);
